/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/information_circled_medium'
export default icon
